import styles from './InfoStrip.module.scss';

interface InfoStripLogotypeProps {
  src: string;
  srcSet?: string;
  alt: string;
}

interface InfoStripProps {
  logotype?: InfoStripLogotypeProps;
  ariaLabel: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  testId?: string;
}

export const InfoStrip = ({ logotype, ariaLabel, children, action, testId }: InfoStripProps) => (
  <section className={styles.strip} aria-label={ariaLabel} data-testid={testId}>
    <div className={styles.content}>
      {logotype && (
        <img
          src={logotype.src}
          srcSet={logotype.srcSet}
          alt={logotype.alt}
          className={styles.logotype}
        />
      )}
      {children}
    </div>
    {action}
  </section>
);
